---
de:
  activerecord:
    attributes:
      api/key:
        company_ids: Unternehmenszugang
        description: Beschreibung
        name: Name
        token: Token
      asset_comment:
        content: Nachricht
        period: Periode
        periods:
          monthly: Monatlich
          quarterly: Quartalsweise
          yearly: Jährlich
        power_plant_id: Kraftwerk
      bilateral_data:
        kaia_trade_metric_name: Kaia Trade Metrikname
        ownership_share: Eigentumsanteil
      budget_forecast:
        avg_price: Durchschnittspreis
        price_area: Preiszone
        volume_percent: Volumen in Prozent
      company:
        availability_analysis_enabled: Verfügbarkeitsanalyse aktivert
        benchmarking: Benchmarking aktiviert
        business_id: Geschäfts-ID
        commercial_scada_enabled: Commercial SCADA aktiviert
        detect_water_loss_downtime_enabled: Erkennung von Wasserverlust-Ausfällen aktiviert
        environmental_flow_tracking_enabled: Mindestabflussverfolgung aktiviert
        follow_up_enabled: Not translated
        liquidity_planning_enabled: Liquiditätsplanung aktiviert
        market_outlook_enabled: Marktaussichten aktiviert
        om_dashboard_enabled: O&M-Dashboard aktiviert
        ppa_pricing_enabled: PPA-Preisbildung aktiviert
        remove_logo: Logo entfernen
        task_management_enabled: Aufgabenverwaltung aktiviert
        url_facebook: Facebook
        url_homepage: Homepage
        url_instagram: Instagram
        url_linked_in: LinkedIn
        white_labeling: White Labeling aktiviert
      company_responsible:
        power_plants: Kraftwerke
        responsible: Verantwortlich
      contract:
        active: Aktiv
        counterpart: Vertragspartner
        end_date: Vertragsende
        open_ended: unbefristeter Vertrag
        power_plant: Kraftwerke
        power_plants: Kraftwerke
        start_date: Vertragsbeginn
        type: Vertragstyp
      downtime_event:
        comment: Kommentar
        component: Hauptkomponente
        ends_at: Ende des Zeitraums
        insurance: Versicherungsanspruch
        power_plant_id: Kraftwerk
        reason: Grund
        starts_at: Beginn des Zeitraums
        total: Gesamt
        verified: Verifiziert
        volume: Volumen
        volume_hint: Durchschnittliche nicht verfügbare Kapazität pro Stunde
        volume_set_manually: Volumen manuell festlegen
        volume_should_have_been: Durchschnittliches erwartetes Volumen pro Stunde im Zeitraum
      event:
        active: aktiv
        alarm_categories: Alarmkategorien
        component: Komponent
        duration: Dauer
        ends_at: Bis
        energy_loss_mwh: Energieverluste (MWh)
        operational_status: Betriebsstatus
        starts_at: Von
        unavailable_power_kw: Nicht verfügbare Leistung (kW)
        yield_loss: Ertragsverluste (%{currency})
      fall_lease:
        amount: Anzahl
        code: Kode
        description: Beschreibung
        month: Monat
        owner: Eigentümer
        period: Periode
        year: Jahr
      feature_request:
        author: Autor
        category: Kategorie
        date: Datum
        status: Status
        title: Titel
        upvotes: Upvotes
      feed_in_tariff_data:
        limit_type: Begrenzungsart
        limit_types:
          fixed_price: Festpreis
          price: Preis
        limit_value: Grenzwert
      hedging_data:
        limit_type: Begrenzungsart
        limit_types:
          percent: Prozent
          volume: Volumen
        limit_value: Grenzwert
        price: Preis
        strategies:
          monthly: Monatlich
          pay_as_produced: Pay as Produced
          quarterly: Vierteljährlich
          yearly: Jährlich
        strategy: Strategie
      hydro/asset:
        bypass_valve: Bypass-Ventil
        concession_date: Konzessionsdatum
        pipe_rupture_valve: Rohrbruch-Ventil
        river_name: Fluss
        start_stop_power_fraction: Start/Stopp-Leistungsanteil
        start_stop_power_fraction_hint: Leistungsänderung als Anteil der Nennleistung in 15 Min, die einen Start/Stopp markiert
        winter_closed: Winter geschlossen
      hydro/environmental_flow_breakpoints:
        day: Day
        flow: Flow
      hydro/generator:
        effect_limitation: Externe Begrenzung
        efficiency_percent: Effizienz
        installed_capacity_mva: Leistung [MVA]
        power_factor_percent: Leistungsfaktor
      hydro/intake:
        dam_length: Damm-Länge [m]
        dam_width_streamwise: Damm-Breite [m]
        intake_type: Fassung Typ
        lat: Breitengrad
        lng: Längengrad
        lower_alert_limit: Untere Alarmgrenze
        masl: Fassung Höhe
        trash_rack_cleaner: rechenreinigungsanlage
        upper_alert_limit: Obere Alarmgrenze
        upstream_depth: Oberstromtiefe [m]
      hydro/model_param:
        bypass_max: Bypass max
        bypass_min: Bypass min
        continuous_dispatch: Kontinuierlicher Einsatz
        discharge_max: Durchfluss max
        discharge_min: Durchfluss min
        energy_deviation_threshold: Schwellenwert Energieabweichung
        energy_equivalent: Energieäquivalent
        net_head_masl_bound_max: Nettofallhöhe Grenze max (m ü. M.)
        net_head_masl_bound_min: Nettofallhöhe Grenze min (m ü. M.)
        overflow_protection: Überlaufschutz
        p_max_overflow: Maximale Produktion bei Überlauf
        production_max: Maximalproduktion
        production_min: Mindestproduktion
        production_min_runtime_hours: Laufzeit bei Mindestlast
        production_sensitivity_max: Produktionssensitivität max
        production_sensitivity_min: Produktionssensitivität min
        resample_to: Resampling auf
        reservoir_max_masl: Speicher max (m ü. M.)
        reservoir_min_masl: Speicher min (m ü. M.)
        reservoir_target_percentage: Speicherziel
        runoff_scale_factor: Skalierungsfaktor Abfluss
        startup_override_production: Anfahrproduktion (Übersteuerung)
        use_runoff_data: Abflussdaten verwenden
      hydro/penstock:
        diameter: Durchmesser
        length: Länge
        material: Material
        net_head_loss_percent: Netto Gefälle Verlüste
        risk_category: Risikokategorie
      hydro/precipitation_field:
        aborigines: indigene Völker
        area: Fläche
        avg_flow_area: Durchschnitt Fläche Einzugsgebiet
        field_length: Feldlänge
        forest_size_percent: Größe des Waldes
        glacier_size_percent: Größe des Gletschers
        lat: Breitengrad
        lng: Längengrad
        mountain_size_percent: Größe des Bergs
        sea_size_percent: Größe des Seees
        swamp_size_percent: Größe des Sumpfes
      hydro/reservoir:
        artificial_reservoir: Kunstliches Reservoir
        gross_dammed_area: Brutto-Staufläche
        gross_power_density: Brutto-Leistungsdichte
        highest_reservoir_value: Höchster Reservoir Wert
        lat: Breitengrad
        lng: Längengrad
        lowest_reservoir_value: Niedrigster Reservoir Wert
        name: Name
        net_dammed_area: Netto-Staufläche
        net_power_density: Netto-Leistungsdichte
        reservoir_name: Name des Reservoirs
        reservoir_volume: Reservoir-Volumen
        risk_category: Risikokategorie
        surface_area: Fläche
      hydro/river:
        anadromous_fish: anadromer Fisch
        name: Name
        river_gradient: Flussgefälle
        river_length: Flusslänge
        watercourse: Gewässer
        watercourse_area: Gewässerfläche
      hydro/transformer:
        capacity_mva: Leistung [MVA]
        effect_limitation: Wirkungsbegrenzung
        efficiency_percent: Effizienz
      hydro/turbine:
        efficiency_percent: Effizienz (bei normalen Bedingungen)
        efficiency_percent_short: Effizienz
        installed_effect_mw: Leistung [MW]
        masl: Turbine Höhe
        max_throughput_operational: Max. op. Durchsatz
        min_throughput_operational: Min. op. Durchsatz
        q_min_loss_percent: Q min Verlust
        turbine_type: Turbinentyp
      label:
        color: Farbe
        name: Name
      news_item:
        accessible_by: Bezogen auf
        allow_comments: Kommentare zulassen
        author: Autor
        body: Haupttext
        category: Kategorie
        community_access: Community-Post
        companies: Unternehmen
        date: Hinzugefügt am
        image: Bild
        image_position: Bildposition
        include_subsidiaries: Tochtergesellschaften einbeziehen
        internal_post_landowner_access: Landeigentümerzugang
        portfolio_access: Portfolio
        posts:
          one: Beitrag
          other: Beiträge
        power_plants: Kraftwerke
        title: Titel
      nve_metadata:
        building_type: Gebäude Typ
        building_types:
          surface: Fläche
          surface_underground: Basierend auf Unter- oder Oberfläche
          underground: Untergrund
        bypasswater_downstream_powerplant_label: WDurchlauf von Wasser zur unteres Kraftwerk (NVE ref. nr)
        date_inital_utilization_of_waterfall: Datum der ursprünglichen Nutzung des Wasserfalls
        date_oldest_power_producing_part: Datum des ältesten Stromproduktions-Teils
        energy_equivalent: Energieäquivalent [kWh/m³]
        floodwater_downstream_powerplant_label: Überschwemmungswasser für unteres Kraftwerk (NVE ref. nr)
        min_throughput: Min. Durchsatz
        min_throughput_unit: Min. Durchsatz [m^3/sec]
        nve_bypasswater_downstream_powerplant: Wasserumgehung für unteres Kraftwerk
        nve_floodwater_downstream_powerplant: Überschwemmungswasser für unteres Kraftwerk
        nve_production_downstream_powerplant: Produktion für unteres Kraftwerk
        powerplant_type: Kraftwerk Typ
        powerplant_types:
          reservoir: Stauseekraftwerk
          run_of_river: Laufwasserkraftwerk
        precipitation_area: Niederschlagsgebiet
        production_downstream_powerplant_label: Produktion für unteres Kraftwerk (NVE Ref. nr)
        regine_nr: Regine nr
        sp_nr_point_reference: Sp nr Zeigerreferenz
        sp_nr_watercourse: Sp nr Gewässer
      power_plant:
        absorption_capacity: Max. Durchsatz
        asset_class: Anlagenklasse
        axpo_id: Axpo ID
        bazefield_site_id: Bazefield Site ID
        biodiversity_sensitive_areas: Biodiversität empfindliche Bereiche
        climate_future_ref: Climate future-Referenz
        co2_emission: CO2-Emission
        collect_weather: Wetterdaten sammeln
        commissioning_date: Inbetriebnahmedatum
        company_id: Unternehmen
        company_name: Company name
        continuous_forecast_enabled: Kontinuierliche Prognose aktiviert
        country_id: Land
        county: Region/Landkreis
        county_name: Name Region/Landkreis
        datastream: Datastream
        day_ahead_forecast_enabled: Prognose für den nächsten Tag aktiviert
        downtime_analysis: Ausfallanalyse
        ecs_id: ECS ID
        elcert: Elcert
        elcert_ends_on: Elcert Ende
        elcert_starts_on: Elcert Start
        external_id: Nest ID
        forecast_query_enabled: Prognoseabfrage aktiviert
        forecasted_budget: Vorhergesagtes Budget
        generator_capacity_mva: Generator-Kapazität [MVA]
        go_date: HKN Ablaufdatum
        greenbyte_site_id: Greenbyte Site ID
        grid_owner: Netzbetreiber
        gurusoft_tags: Gurusoft-Tags
        image: Neues Bild hochladen
        image_attribution: Bild-Zuschreibung
        in_operation: In Betrieb
        intake_count: Anzahl Fassungen
        intake_lat_lng: Fassung Koordinaten
        internal_notes: Interne Notizen
        kaia_uuid: Kaia UUID
        krasys_live_measurement_values: KRASYS Live-Messwerte
        kwh_m3: Energieäquivalent
        lat: Breitengrad
        lng: Längengrad
        max_effect: Hist. Max. Leistung
        max_throughput_operational: Max. op. Durchsatz
        metering_point_id: Messstellen-ID
        min_operational_power: Min. Betriebsleistung [MW]
        min_production_effect: Ausfall-Schwelle [MW]
        min_throughput_operational: Min. op. Durchsatz
        model_parameters: Modellparameter
        municipality: Gemeinde
        municipality_name: Name Gemeinde
        name: Name
        net_head_masl: Netto Gefälle der Anlage
        nispera_id: Nispera ID
        num_segments: Anzahl der Segmente
        nve_gwh: Jahresproduktion
        nve_nr: NVE-Nr.
        nve_status: Status
        optimization_model: Optimierungsmodell
        owner: Eigentümer
        periods: Zeiträume
        plant_effect_mw: Anlagen-Kapazität [MW]
        postcode: Postleitzahl
        price_area: Preiszone
        price_dependent_bid_override: Preisabhängige Gebotsüberschreibung
        production_simulation_plan_enabled: Produktionssimulationsplan aktiviert
        project: Projekt
        rated_power_mw: Turbinen-Kapazität [MW]
        remove_image: Bild entfernen
        reservoir: Reservoir
        scada_int_id: Scada International ID
        scada_int_tag: Scada International Tag
        settled_volume_source: Siedelvolumen-Quelle
        shadow_testing: Schattentests
        shadow_tracking: Schattenverfolgung
        site_address: Adresse der Anlage
        station_lat_lng: Koordinaten der Anlage
        statkraft_customer_id: Statkraft Kunden-ID
        turbine_count: Turbinenzahl
        turbine_level_masl: Turbinenhöhe
        turbine_type: Turbine Typ
        unsettled_volume_source: Unsiedelvolumen-Quelle
        use_price_dependent_bid: Preisabhängiges Gebot
        vertical_drop: Netto Gefälle
        weather_source: Wetterquelle
        wikipedia_page_id: Wikipedia-Artikel-ID
        xledger_project_id: Xledger Projekt-ID
        yearly_production: Normale Produktion [GWh]
      power_plant_responsible:
        company_responsible: Verantwortlich
        role_values:
          accounting: Buchhaltung
          asset_manager: Vermögensverwalter
          auditor: Wirtschaftsprüfer
          balancing_responsible: Verantwortlicher für die Bilanzierung
          ceo: CEO
          guarantees_of_origin_sales: Verkauf von Herkunftsnachweisen
          hv_leader: HV-Verantwortlicher
          insurance_broker: Versicherungsmakler
          internal_grid_om: Interne Netz-Wartung und -Instandhaltung
          internet_provider: Internetanbieter
          operator: O&M-Verantwortlicher
          owner_representative: Vertreter des Eigentümers
          plant_supervisor: Anlage Supervisor
          road_maintenance: Straßeninstandhaltung
          snow_ploughing: Schneeräumung
          substation_om: Umspannwerk-Wartung und -Instandhaltung
          turbine_om: Turbinenwartung und -instandhaltung
          vta: MwSt
          waste_management: Abfallmanagement
        roles: Rollen
      responsible:
        email: Email
        name: Name
        phone: Telefon
        user_id: Benutzer
      scheduled_downtime_event:
        comment: Kommentar
        component: Hauptkomponente
        curtailed_mode: Eingeschränkter Modus
        ends_at: Ende des Zeitraums
        operator_email: E-Mail des Betreibers
        power_plant_id: Kraftwerk
        reason: Grund
        starts_at: Beginn des Zeitraums
        volume: Volumen
        volume_hint: Durchschnittliche nicht verfügbare Kapazität pro Stunde
      self_consumption_data:
        currency_code: Währung
        generator_auxiliary_consumption_price_mwh: Kosten Eigenbedarf Produktionsanlage pro MWh
        grid_injection_price_mwh: Netzeinspeisevergütung pro MWh
        grid_injection_spot: Netzeinspeisevergütung gemäss Spot-Preis
        self_consumption_price_mwh: Eigenverbrauchsvergütung pro MWh
      sensor:
        lower_alert_limit: Untere Alarmgrenze
        upper_alert_limit: Obere Alarmgrenze
      solar/asset:
        anomaly_thresholds_help: 'Default-Parameter für die Anomalieerkennung behalten mit: <code>&#123;&quot;idc&quot;:null,&quot;udc&quot;:null,&quot;fuac&quot;:null,&quot;min_gpoa_availability_wm2&quot;:60.0&#125;</code>.<br /> Mögliche komplette anlagenspezifische Parametrisierung mit Default-Parametern:'
        anomaly_thresholds_raw: Schwellwerte Fehlererkennung
        avg_yearly_solar_radiation: Durchschnittliche jährliche Solareinstrahlung
        data_source_settings_help: 'Einstellungen Datenquelle in json format. Zwingend notwendiger Attribut um die Datenquelle zu definieren: <code>type</code>.<br /> Siehe <a href="https://github.com/kaia/captiva_portal/wiki/Solar-data-source-settings.">Kaia portal wiki</a> für zusätzliche Attribute.<br /> Beispiel für Solar-Log FTP:'
        data_source_settings_raw: Einstellungen Datenquelle
        full_operating_hours: Volllaststunden
        ml_learning_parameters_help: 'Minimale Einstellungen ohne Wechselrichter- oder MPPT-Substitution: <code>&#123;&quot;timestamp_from&quot;:&quot;2023-01-01T00:00:00Z&quot;,&quot;timestamp_to&quot;:&quot;2024-01-01T00:00:00Z&quot;,&quot;inv_replacements&quot;:[],&quot;mppt_replacements&quot;:[]&#125;</code>.<br /> Biespiel mit Komponenten-Substitution:'
        ml_learning_parameters_raw: ML Einstellungen
        storage_unit_present: Batteriespeicher vorhanden
        substation_lat: Unterstation LAT
        substation_lng: Unterstation LONG
        substation_masl: Unterstation  Höhe
      solar/field:
        installed_power_kwp: Installierte Leistung
        module_efficiency_percent: Modul-Effizienz
        mounting_mode: Montage Modus
        mounting_modes:
          freestanding: freistehende (ungehinderte Luftzirkulation)
          fully_insulated: Vollständig isolierte Rückseite
          intermediary: Zwischenstufe (eingeschränkte Luftzirkulation)
        name: Name
        orientation: Ausrichtung
        tilt: Tilt
      solar/inverter:
        external_id: Mapping Datenquelle
        installed_power_kwp: Installierte Leistung
        modules_count: Anzahl Module
        name: Name
        signal_mapping_raw: Signal mapping
        solar_inverter_type_id: Welchselrichter-Modell
        valid_from: Gültig ab
        valid_to: Gültig bis
      solar/inverter_type:
        maximal_power_kva: Maximale Schenleistung
        model: Bezeichnung
        mppt_count: Anzahl MPPTs
        nominal_power_kw: Nominale Wirkleistung
        supplier: Hersteller
        supplier_id: ID
      solar/model_param:
        production_max: Maximalproduktion
        production_min: Mindestproduktion
        production_sensitivity_max: Produktionssensitivität max
        production_sensitivity_min: Produktionssensitivität min
      solar/module_type:
        alpha_isc: Temperaturkoeffizient ISC Alpha
        beta_uoc: Temperaturkoeffizient Uoc Beta
        cell_type: Zellentechnologie
        cells_in_series: Zellen in Reihe
        current_impp_a: MPP-Strom
        current_isc_a: Kurzschlussstrom
        gamma_pmpp: Temperaturkoeffizient Pmpp Gamma
        length_mm: Länge
        model: Bezeichnung
        module_efficiency: Modulwirkungsgrad
        noct_degc: NOCT-Temperatur
        power_pmpp_w: Nennleistung
        supplier: Hersteller
        supplier_id: ID
        system_voltage_v: Maximale Systemspannung
        voltage_umpp_v: MPP-Spannung
        voltage_uoc_v: Leerlaufspannung
        width_mm: Breite
      solar/mppt:
        input_number: Eingang
        installed_power_kwp: Installierte Leistung
        modules_efficiency: Modulwirkungsgrad
        modules_in_series: Module in Serie
        modules_surface_m2: Fläche angeschlossene Module
        signal_mapping_raw: Signalzuweisung
        solar_field_id: Feld
        solar_module_type_id: Solarmodul
        source_name: Bezeichnung in Quelldaten
        stringbox_name: SCB name
        strings_in_parallel: Strings in Parallel
      spot_data:
        ownership_share: Eigentumsanteil
      supplier:
        add_new: Neuen Lieferanten hinzufügen
        category: Kategorie
        type: Typ
        url_facebook: Facebook
        url_homepage: Homepage
        url_instagram: Instagram
        url_linked_in: LinkedIn
      user:
        avatar: Avatar
        avatar_lowercase: Avatar
        company_ids: Unternehmen
        currency_code: Währung
        email: E-Mail
        firstname: Vorname
        job_title: Berufsbezeichnung
        lastname: Nachname
        locale: Sprache des Portals
        news_email: Wöchentliche Nachrichten per E-Mail
        password: Passwort
        password_confirmation: Passwort bestätigen
        phone: Telefon
        power_plant_ids: Kraftwerke
        short_bio: Kurzbiografie
      wind/asset:
        activity: Aktivität
        avg_yearly_wind_speed: Durchschnittliche jährliche Windgeschwindigkeit
        data_source_settings_raw: Einstellungen Datenquelle
        full_operating_hours: Volllaststunden
        recycle_share_percent: Recycling-Anteil
        substation_lat: Unterstation LAT
        substation_lng: Unterstation LONG
        substation_masl: Unterstation  Höhe
      wind/availability_calculation:
        contractual_availability_calculation: Berechnung der vertraglichen Verfügbarkeit
        contractual_availability_energy_based: Vertragliche Verfügbarkeit
        energy_based_availability: Energiebasierte Verfügbarkeit
        time_based_availability: Zeitbasierte Verfügbarkeit
      wind/availability_mapping:
        alarm_category: Alarmkategorie
        alarm_category_types:
          environmental: Umwelt
          force_majeure: Höhere Gewalt
          grid: Netz
          manufacturer: Hersteller
          no_data: Keine Daten
          owner: Eigentümer
          turbine_ok: Turbine OK
        contractual_availability: Vertragliche Verfügbarkeit
        mapping_types:
          neglected: Unbeachtet
          ready: Verfügbar
          unavailable: Unverfügbar
        total_availability: Gesamte Verfügbarkeit
      wind/availability_target:
        contractual_availability_target: Ziel vertragliche Verfügbarkeit
        year: Jahr
      wind/event_mappings:
        alarm_category_type: Alarmkategorie
        turbine_event_code: Turbine-Ereigniscode
        turbine_event_name: Turbine-Ereignisname
      wind/model_param:
        production_max: Maximalproduktion
        production_min: Mindestproduktion
        production_sensitivity_max: Produktionssensitivität max
        production_sensitivity_min: Produktionssensitivität min
      wind/power_curve:
        air_density_kgm3: Luftdichte
        default: Standard
        file: Datei
        historical_power_curve: Historische Leistungskurve
        manufacturer_power_curve: Hersteller-Leistungskurve
        name: Name
        power: Leistung
        power_kw: Leistung [kW]
        show: Leistungskurve visualisieren
        title: Leistungskurve
        wind_speed: Windgeschwindigkeit
        wind_speed_ms: Windgeschwindigkeit [m/s]
      wind/turbine:
        commissioning_year: Inbetriebnahmejahr
        external_source_id: ID Datenquelle
        ground_altitude_masl: Geländehöhe
        hub_height: Nabehöhe
        lat: Breitengrad
        lng: Längengrad
        name: Name
        tip_height: Spitzenhöhe
        wind_turbine_type_id: Turbinentyp
      wind/turbine_type:
        meteomatics_id: Meteomatics Turbinen-ID
        name: Name
        rated_power_kw: Nennleistung [kW]
        rotor_diameter: Rotordurchmesser [m]
        supplier_id: ID
      work_item:
        budget_cost: Budgetkosten
        closed_on: Geschlossen am
        company_responsible: Verantwortlich
        component: Komponente
        description: Beschreibung
        due_date: Fälligkeitsdatum
        elapsed_cost: Verstrichene Kosten
        forecast_cost: Prognosekosten
        id: ID
        labels: Etiketten
        last_comment: Letzter Kommentar
        power_plant: Kraftwerk
        started_on: Gestartet am
        status: Status
        title: Titel
        valuta: Währung
    errors:
      models:
        budget_forecast:
          volume_forecast: muss zwischen 0 und 100 liegen
        contract:
          too_long: Muss nur ein Kraftwerk sein
        event:
          cannot_change_component_or_operation_status_settled: Komponent oder operational_status_id von einem bestätigten unbeendeten Ereignis kann nicht angepasst werden.
          cannot_delete_settled: Bestätigtes Ereignis kann nicht gelöscht werden.
          cannot_modify_locked_event: Gesperrte Ereignisse können nicht mehr geändert werden.
          cannot_overlap: Zeitliche Überschneidungen von Ereignissen für dieselbe Komponente sind nicht erlaubt.
          cannot_update_settled: Bestätigtes und beendetes Ereignis kann nicht aktualisiert werden.
        market_paramaeter:
          bids_illogical: Der maximale Gebotspreis kann nicht tiefer sein als der minimale Gebotspreis
    models:
      elcert_month:
        one: Elcert-Monat
        other: Elcert-Monat
      go_month:
        one: GoO-Monat
        other: GoO-Monat
